module.exports = __webpack_public_path__ + "img/Room.68602159.svg";